export function uploadCompanyImage(handleDataFetch, format) {
    return new Promise((resolve, reject) => {
        if (window.cloudinary) {
           
            window.cloudinary.openUploadWidget(
                {
                    cloudName: process.env.REACT_APP_API_CLOUDINARY_CLOUD_NAME,
                    uploadPreset: process.env.REACT_APP_API_CLOUDINARY_UPLOAD_PRESET,
                    sources: ["local"],
                    googleApiKey: "<image_search_google_api_key>",
                    showAdvancedOptions: false,
                    cropping: false,
                    multiple: false,
                    clientAllowedFormats: format,
                    singleUploadAutoClose: false,
                    maxFileSize: 1000000,
                    defaultSource: "local",
                    styles: {
                        palette: {
                            window: "#FFFFFF",
                            windowBorder: "#047558",
                            tabIcon: "#047558",
                            menuIcons: "#047558",
                            textDark: "#000000",
                            textLight: "#FFFFFF",
                            link: "#047558",
                            action: "#047558",
                            inactiveTabIcon: "#888888",
                            error: "#F44235",
                            inProgress: "#047558",
                            complete: "#047558",
                            sourceBg: "#FFFFFF",
                        },
                        fonts: {
                            default: {
                                active: true,
                            },
                        },
                    },
                },
                (error, result) => {
                    if (!error && result && result.event === "success") {
                        resolve(result.info);
                        handleDataFetch(result)
                    }
                    if (error) {
                        reject(error);
                    }
                }
            );
        }
    });
}